/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLiquorIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-liquor"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.28 20.18L4.28 17.05Q3.27 16.63 2.74 15.72Q2.2 14.82 2.2 13.75L2.2 6.2Q2.2 5.65 2.59 5.26Q2.98 4.88 3.52 4.88L7.75 4.88Q8.3 4.88 8.69 5.26Q9.07 5.65 9.07 6.2L9.07 13.75Q9.07 14.85 8.49 15.74Q7.9 16.63 6.92 17.05L6.92 20.18L7.7 20.18Q8.25 20.18 8.63 20.55Q9 20.93 9 21.48Q9 22.02 8.63 22.41Q8.25 22.8 7.7 22.8L3.5 22.8Q2.95 22.8 2.58 22.41Q2.2 22.02 2.2 21.48Q2.2 20.93 2.59 20.55Q2.98 20.18 3.52 20.18ZM4.85 10.6L6.42 10.6L6.42 7.53L4.85 7.53ZM13.2 22.8Q12.1 22.8 11.34 22.04Q10.57 21.27 10.57 20.18L10.57 10.38Q10.57 9.55 11.05 8.88Q11.53 8.2 12.32 7.9L13.28 7.55Q13.4 7.5 13.5 7.39Q13.6 7.28 13.6 7.13L13.6 2.33Q13.6 1.85 13.94 1.52Q14.28 1.2 14.75 1.2L18.6 1.2Q19.07 1.2 19.43 1.52Q19.77 1.85 19.77 2.33L19.77 7.13Q19.77 7.28 19.86 7.39Q19.95 7.5 20.07 7.55L21.02 7.9Q21.82 8.2 22.31 8.88Q22.8 9.55 22.8 10.38L22.8 20.18Q22.8 21.27 22.02 22.04Q21.25 22.8 20.18 22.8ZM16.25 4.88L17.13 4.88L17.13 3.85L16.25 3.85ZM13.22 11.55L20.15 11.55L20.15 10.35L19.23 10.05Q18.3 9.78 17.71 9.01Q17.13 8.25 17.13 7.28L17.13 7.28L16.25 7.28L16.25 7.28Q16.25 8.25 15.65 9.01Q15.05 9.78 14.15 10.05L13.22 10.35ZM13.22 20.15L20.15 20.15L20.15 18.25L13.22 18.25Z" fill={color} />
    </svg>
  );
}
